
import { Colors } from '../consts/Colors';

export default class Card extends Phaser.GameObjects.Container {
    constructor(scene, x, y, cardData, deck) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.isDone = false;


        this.img = cardData.image + "Black"
        this.trueId = cardData.trueId;
        this.trueId2 = cardData.trueId2;
        this.zoneId = cardData.zoneId;
        this.correct = cardData.correct
        this.correct1 = cardData.correct1
        this.correct2 = cardData.correct2
        this.corrections = cardData.corrections

        this.deck = deck

        this.cardImage = this.scene.add.image(0, -30, this.img).setOrigin(0.5);
        this.add(this.cardImage);

        this.setSize(this.cardImage.width, this.cardImage.height);
        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this)

        // Remove les anciens listener
        this.scene.input.removeListener('dragstart')
        this.scene.input.removeListener('drag')
        this.scene.input.removeListener('drop')
        this.scene.input.removeListener('dragend')

        // Fonctions basiques du drag&drop
        this.scene.input.on('dragstart', (pointer, gameObject) => {
            gameObject.setDepth(10)
            this.dragStartAnnim()
            this.scene.isDragging = true
        });

        this.scene.input.on('drag', (pointer, gameObject, dragX, dragY) => {
            gameObject.x = dragX;
            gameObject.y = dragY;
            // gameObject.setDepth(10)
            this.scene.input.setDefaultCursor('grabbing');
            this.scene.itemsAll.forEach(x => {
                x.setDepth(0)

            })
        });

        this.scene.input.on('drop', (pointer, gameObject, dropZone) => {
            gameObject.setDepth(0)
            // this.scene.isDragging = false
            this.scene.input.setDefaultCursor('default')
            this.drop(pointer, gameObject, dropZone)
        });

        this.scene.input.on('dragend', (pointer, gameObject, dropped) => {
            this.scene.input.setDefaultCursor('default')
            gameObject.setDepth(0)
            // this.scene.isDragging = false
            if (x.isDone) {
                x.setActive()
            }
            this.dragEnd(pointer, gameObject, dropped)
        });

        this.scene.input.on('dragenter', (pointer, gameObject, dropZone) => {
            dropZone.dragOnPointerOver()
        });

        this.scene.input.on('dragleave', (pointer, gameObject, dropZone) => {
            dropZone.dragOnPointerOut()
        });


    }
    drop(pointer, gameObject, dropZone) {
        if (dropZone.zoneId == gameObject.zoneId) {
            if (gameObject.zoneId == 3) {
                if (dropZone.trueId == gameObject.trueId) {
                    this.scene.itemsAll.forEach(x => {
                        if (x.trueId == gameObject.trueId) {
                            x.setDone()
                        }
                    })

                } else if (dropZone.trueId != gameObject.trueId) {
                    dropZone.item.setTint(0xFFFFFF);
                    this.scene.itemsAll.forEach(x => {
                        if (x.trueId == gameObject.trueId) {
                            x.setDone()
                        }
                    })
                }
                if (dropZone.otherId == 7) {
                    this.deck.setDeckTrue(gameObject.correct2)
                } else {
                    this.deck.setDeckTrue(gameObject.correct)
                }
            } else {
                if (dropZone.trueId == gameObject.trueId) {
                    dropZone.setDone()

                } else if (dropZone.trueId != gameObject.trueId) {
                    dropZone.item.setTint(0xFFFFFF);
                    this.scene.itemsAll.find(x => x.trueId == gameObject.trueId).setDone()
                }

                this.deck.setDeckTrue(gameObject.correct)
            }

            this.scene.game.data.cardNumber++
        } else {
            dropZone.setWrong(this.img)
            if (gameObject.zoneId == 6 && dropZone.zoneId == 3 && dropZone.otherId == 7) {
                this.deck.setDeckFalse(this.corrections[5].texte)
            } else {
                this.corrections.forEach(x => {
                    let y = x.ids.includes(dropZone.zoneId)
                    if (y) {
                        this.deck.setDeckFalse(x.texte)
                    }
                })
            }
        }
        gameObject.destroy()
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            // On garde la position de la zone si on lache en déhors
            if (this.keepZonePosition) {
                gameObject.x = gameObject.input.dragStartX;
                gameObject.y = gameObject.input.dragStartY;
            } else {
                // On reset la card à sa position initiale si on ne garde pas la position
                gameObject.resetPosition()
            }
        }
    }

    setDone() {
        this.isDone = true
    }

    resetPosition(duration) {
        if (duration == undefined) {
            duration = 300
        }


        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y,
            scale: 1,
            onComplete: () => {
                this.setInteractive({ useHandCursor: true })
            }
        })
    }
    dragStartAnnim() {
        this.scene.tweens.add({
            targets: this,
            duration: 200,
            scale: 0.7,
            onComplete: () => {
            }
        })
    }

}